interface BookingCartQueryPeriod {
  start: Date
  end: Date
}

interface BookingCartQueryItem {
  service: {
    id: number
  }
  quantity: number
}

export interface BookingCartQuery {
  [key: string]: string
  startAt: string
  endAt: string
  items: string
}

export interface DeserializedBookingCartQuery {
  start: Date
  end: Date
  quantitiesByServiceId: Map<number, number>
}

function getQueryString(value: unknown) {
  const normalizedValue = Array.isArray(value) ? value[0] : value
  return typeof normalizedValue === 'string' ? normalizedValue : undefined
}

export function serializeBookingCartQuery(
  period: BookingCartQueryPeriod,
  items: BookingCartQueryItem[],
): BookingCartQuery {
  return {
    startAt: period.start.toISOString(),
    endAt: period.end.toISOString(),
    items: items.map(item => `${item.service.id}:${item.quantity}`).join(','),
  }
}

export function deserializeBookingCartQuery(query: Record<string, unknown>): DeserializedBookingCartQuery | undefined {
  const start = new Date(getQueryString(query.startAt) || '')
  const end = new Date(getQueryString(query.endAt) || '')
  const quantitiesByServiceId = new Map<number, number>()

  for (const serializedItem of (getQueryString(query.items) || '').split(',')) {
    const [serializedServiceId = '', serializedQuantity = ''] = serializedItem.split(':')
    const serviceId = Number(serializedServiceId)
    const quantity = Number(serializedQuantity)

    if (Number.isInteger(serviceId) && serviceId > 0 && Number.isInteger(quantity) && quantity > 0) {
      quantitiesByServiceId.set(serviceId, quantity)
    }
  }

  if (!quantitiesByServiceId.size || Number.isNaN(start.getTime()) || Number.isNaN(end.getTime()) || start >= end) {
    return
  }

  return {
    start,
    end,
    quantitiesByServiceId,
  }
}
